import React from 'react';
import { Card, CardContent, CardActionArea, Grid, TextField, Typography, Box, useMediaQuery, useTheme, Grow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import DeveloperBoardIcon from '@material-ui/icons/DeveloperBoard';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import RoomIcon from '@material-ui/icons/Room';
import DateRangeIcon from '@material-ui/icons/DateRange';
import ScannerIcon from '@material-ui/icons/Scanner';
import { ChangePassword } from '../Users';
import { PresenceButton } from '../components/CustomAppBar';
import DateFnsUtils from "@date-io/date-fns";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import { default as AllInbox, default as AllInboxIcon } from "@material-ui/icons/AllInbox";
import AppsIcon from "@material-ui/icons/Apps";
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import BarChartIcon from '@material-ui/icons/BarChart';
import CollectionsBookmarkIcon from "@material-ui/icons/CollectionsBookmark";
import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber";
import ContactsIcon from '@material-ui/icons/Contacts';
import EditLocationIcon from "@material-ui/icons/EditLocation";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import HomeIcon from '@material-ui/icons/Home';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import ListAltIcon from '@material-ui/icons/ListAlt';
import LocalAtmIcon from "@material-ui/icons/LocalAtm";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import MapIcon from "@material-ui/icons/Map";
import MoneyOffIcon from "@material-ui/icons/MoneyOff";
import MoreIcon from "@material-ui/icons/More";
import PermContactCalendarIcon from "@material-ui/icons/PermContactCalendar";
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import PublishIcon from "@material-ui/icons/Publish";
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import QueueIcon from "@material-ui/icons/Queue";
import ReceiptIcon from "@material-ui/icons/Receipt";
import SelectAllIcon from '@material-ui/icons/SelectAll';
import SettingsIcon from '@material-ui/icons/Settings';
import StoreIcon from "@material-ui/icons/Store";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import SystemUpdateAltIcon from "@material-ui/icons/SystemUpdateAlt";
import TableChartIcon from '@material-ui/icons/TableChart';
import TimelineIcon from "@material-ui/icons/Timeline";
import TocIcon from "@material-ui/icons/Toc";
import TuneIcon from '@material-ui/icons/Tune';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import it from "date-fns/locale/it";
import { createBrowserHistory } from "history";
import "leaflet-draw/dist/leaflet.draw-src.css";
import polyglotI18nProvider from "ra-i18n-polyglot";
import italianMessages from "ra-language-italian";
import {Admin, Link, Resource} from "react-admin";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { Route } from "react-router-dom";
import Alert from "@material-ui/lab/Alert";

import {
    TbRouteScan, TbCalendarWeekFilled, TbCashRegister, TbMapUp, TbPackages, TbListLetters, TbReportMoney,
    TbFileTypeXml
} from "react-icons/tb";
import { BsCalendar2Week, BsUiChecks, BsQrCode, BsInfoCircle, BsJournalPlus, BsJournalMinus, BsPersonWorkspace, BsPersonVideo2 } from "react-icons/bs";
import { PiListChecksBold, PiTableLight } from "react-icons/pi";
import { FaFileImport, FaFileInvoice, FaFileInvoiceDollar, FaRegHandshake, FaTruckLoading, FaUmbrellaBeach } from "react-icons/fa";
import { GiFamilyTree, GiGps, GiReceiveMoney } from "react-icons/gi";
import {FaMoneyBillTransfer, FaMoneyCheckDollar, FaPeopleCarryBox, FaPersonChalkboard} from "react-icons/fa6";
import {LuFolderTree, LuMonitorCheck, LuPackageCheck, LuTableColumnsSplit} from "react-icons/lu";
import { GrConfigure } from "react-icons/gr";
import { BiQrScan } from "react-icons/bi";
import { MdForklift, MdOutlineBadge, MdOutlineCategory, MdOutlineMailOutline } from "react-icons/md";
import { TfiAgenda } from "react-icons/tfi";
import { GoCodescanCheckmark } from "react-icons/go";
import { getUser, hasPermission } from '../authProvider';


const useStyles = makeStyles(theme => ({
  card: {
    margin: theme.spacing(1),
    position: 'relative',
    overflow: 'hidden',
    borderRadius: theme.spacing(2),
    // background: 'linear-gradient(135deg, rgba(255,255,255,0.9), rgba(240,240,255,0.9))',
    transition: 'transform 0.3s, box-shadow 0.3s',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: theme.shadows[6],
    },
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
  },
  iconBox: {
    fontSize: 48,
    color: theme.palette.primary.main,
    marginRight: theme.spacing(1),
    transition: 'transform 0.5s',
    '$card:hover &': {
      transform: 'rotate(15deg) scale(1.1)',
    },
  },
  searchField: {
    backgroundColor: '#fff',
    borderRadius: theme.shape.borderRadius,
    transition: 'box-shadow 0.3s',
    '&:focus-within': {
      boxShadow: `0 0 0 2px ${theme.palette.primary.light}`,
    },
  },
}));

interface FirstPageCardProps {
  title: string;
  url: string;
  icon: React.ReactNode;
  delay: number;
}

const FirstPageCard: React.FC<FirstPageCardProps> = ({ title, url, icon, delay }) => {
  const classes = useStyles();

  return (
    <Grow in timeout={500 + delay}>
      <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
        <Card className={classes.card} elevation={3}>
          <Link to={url} style={{ textDecoration: 'none', color: 'inherit'}}>
            <CardContent className={classes.content} style={{  paddingBottom: "10px" }}>
              <Box className={classes.iconBox}>{icon}</Box>
              <Typography variant="h6" component="h3" style={{ flexGrow: 1, textAlign: 'center' }}>
                {title}
              </Typography>
            </CardContent>
          </Link>
        </Card>
      </Grid>
    </Grow>
  );
};

export const FirstPage: React.FC<any> = ({ permissions }) => {
  const classes = useStyles();
  const user = getUser();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));

  const [search, setSearch] = React.useState('');
  const iconSize = 60;

  const cards = [
    // Primary actions
    {
      hasPermission: permissions?.includes('distribution.change_note'),
      title: "Avvia giri",
      url: "/start_route",
      icon: <TbRouteScan style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('distribution.change_note'),
      title: "WebScanner",
      url: "/qr_scanner",
      icon: <BsQrCode style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('distribution.change_route') && permissions?.includes('distribution.view_segment'),
      title: "TrackMe",
      url: "/trackme",
      icon: <RoomIcon style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('distribution.view_note') || permissions?.includes('base.view_carrierdelivery'),
      title: "DDT Scanner",
      url: "/ddt_scanner",
      icon: <ScannerIcon style={{ fontSize: iconSize }} />
    },
    // Registry
    {
      hasPermission: permissions?.includes('registry.view_site'),
      title: "Sedi logistiche",
      url: "/sites",
      icon: <StoreIcon style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('employees.view_employee'),
      title: "Dipendenti",
      url: "/employees",
      icon: <SupervisorAccountIcon style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('fleet_management.view_vehicle'),
      title: "Veicoli",
      url: "/vehicles",
      icon: <LocalShippingIcon style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('registry.view_subject') && permissions?.includes('registry.change_subject'),
      title: "Soggetti",
      url: "/subjects",
      icon: <BsPersonVideo2 style={{ fontSize: iconSize }} />
    },
    // File Import
    {
      hasPermission: permissions?.includes('file_import.change_importedfile'),
      title: "Carica file",
      url: "/upload",
      icon: <FaFileImport style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('file_import.view_importedfile'),
      title: "File importati",
      url: "/imported-files",
      icon: <PlaylistAddCheckIcon style={{ fontSize: iconSize }} />
    },
    // Distribution
    {
      hasPermission: permissions?.includes('distribution.view_delivery'),
      title: "Missioni",
      url: "/deliveries",
      icon: <BsUiChecks style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('route_management.change_route') && permissions?.includes('distribution.change_delivery'),
      title: "Pianificatore",
      url: "/planner",
      icon: <MapIcon style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('route_management.change_route') && permissions?.includes('distribution.change_route') && permissions?.includes('distribution.change_segment'),
      title: "Giri",
      url: "/routes",
      icon: <TimelineIcon style={{ fontSize: iconSize }} />
    },
    // Warehouse
    {
      hasPermission: permissions?.includes('route_management.view_route'),
      title: "Bacheca giri",
      url: "/board_routes",
      icon: <FaPersonChalkboard style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('route_management.view_route'),
      title: "Monitoraggio giri",
      url: "/routes-monitor",
      icon: <LuMonitorCheck style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('route_management.view_route') && permissions?.includes('distribution.view_route') && permissions?.includes('distribution.view_segment'),
      title: "Carica giri",
      url: "/load-routes",
      icon: <FaTruckLoading style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('route_management.view_route') && permissions?.includes('distribution.view_segment'),
      title: "Carica missioni",
      url: "/load-deliveries",
      icon: <LuPackageCheck style={{ fontSize: iconSize }} />
    },
    // Cash
    {
      hasPermission: permissions?.includes('cash_on_delivery.display_cachet_to_cash_in'),
      title: "Da incassare",
      url: "/cachets",
      icon: <MoneyOffIcon style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('cash_on_delivery.display_cachet_cashed'),
      title: "Incassi",
      url: "/cachet-payments",
      icon: <AttachMoneyIcon style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('cash_on_delivery.view_remittance'),
      title: "Rimesse",
      url: "/remittances",
      icon: <TocIcon style={{ fontSize: iconSize }} />
    },
    // Customers
    {
      hasPermission: permissions?.includes('customers.view_customerorder'),
      title: "Ordini Cliente",
      url: "/customer_orders",
      icon: <BsUiChecks style={{ fontSize: iconSize }} />
    },
    // Articles
    {
      hasPermission: permissions?.includes('distribution.view_note'),
      title: "Bolle",
      url: "/notes",
      icon: <InsertDriveFileIcon style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('route_management.change_route') && permissions?.includes('distribution.change_route') && permissions?.includes('distribution.change_segment'),
      title: "Raggruppamenti",
      url: "/delivery-groups",
      icon: <ListAltIcon style={{ fontSize: iconSize }} />
    },
    // Import extras
    {
      hasPermission: permissions?.includes('file_import.view_missingsubject'),
      title: "Risolvi soggetti",
      url: "/subjects-solver",
      icon: <GroupAddIcon style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('file_import.view_importedfile'),
      title: "Scarica template",
      url: "/supersonica_template_import_files",
      icon: <InsertDriveFileIcon style={{ fontSize: iconSize }} />
    },
    // Accounting - Sales
    {
      hasPermission: permissions?.includes('accounting.change_charge'),
      title: "Tot. valida righe",
      url: "/charges-summary",
      icon: <AccountTreeIcon style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('accounting.change_charge'),
      title: "Valida righe",
      url: "/charges",
      icon: <AccountTreeIcon style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('accounting.change_charge'),
      title: "Tot. prefatture",
      url: "/verified-charges-summary",
      icon: <FaFileInvoice style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('accounting.change_charge') || permissions?.includes('accounting.change_invoice'),
      title: "Prefattura",
      url: "/verified-charges",
      icon: <FaFileInvoice style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('accounting.view_invoice'),
      title: "Fatture",
      url: "/invoices",
      icon: <FaFileInvoiceDollar style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('accounting.view_bankreceipt'),
      title: "Ri.ba.",
      url: "/bank_receipt",
      icon: <ReceiptIcon style={{ fontSize: iconSize }} />
    },
    // Accounting - Schedule
    {
      hasPermission: permissions?.includes('accounting.view_invoicepaymentstatus'),
      title: "Scadenzario",
      url: "/payment_schedule",
      icon: <DateRangeIcon style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('accounting.view_invoicepaymentstatus'),
      title: "Recupero crediti",
      url: "/debt_collection",
      icon: <FaMoneyBillTransfer style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('accounting.view_invoicepaymentstatus'),
      title: "Prima nota",
      url: "/journal_entry",
      icon: <AttachMoneyIcon style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('accounting.view_invoicepaymentstatus'),
      title: "File riconciliazione",
      url: "/reconciliation_file",
      icon: <TbFileTypeXml style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('accounting.view_invoicepaymentstatus'),
      title: "Riconciliazione",
      url: "/reconciliation",
      icon: <LuTableColumnsSplit style={{ fontSize: iconSize }} />
    },
    // HR nested
    {
      hasPermission: permissions?.includes('employees.change_badge'),
      title: "Badge",
      url: "/badges",
      icon: <MdOutlineBadge style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('employees.change_presenceqr'),
      title: "Qr accessi",
      url: "/presence_qr",
      icon: <BiQrScan style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('employees.change_presencezone'),
      title: "Zone timbratura",
      url: "/presence_zones",
      icon: <TbMapUp style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('employees.change_presence'),
      title: "Presenze",
      url: "/presences",
      icon: <AssignmentTurnedInIcon style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('employees.change_presence'),
      title: "Calendario sett.",
      url: "/presences_day",
      icon: <TbCalendarWeekFilled style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('employees.change_presence'),
      title: "Calendario",
      url: "/presences_calendar",
      icon: <BsCalendar2Week style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: hasPermission(permissions, 'base.change_timesheet'),
      title: "Timesheet",
      url: "/presences_calendar_summary",
      icon: <PiTableLight style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('employees.change_presenceqr'),
      title: "Generatore Qr",
      url: "/presence_qr_generator",
      icon: <SelectAllIcon style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('employees.change_presence'),
      title: "Loggati",
      url: "/presences_only_in",
      icon: <AssignmentTurnedInIcon style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('employees.view_workpermit'),
      title: "Permessi",
      url: "/workpermits",
      icon: <FaUmbrellaBeach style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: permissions?.includes('base.change_workpermit_c1') || permissions?.includes('base.change_workpermit_c2') || permissions?.includes('base.change_workpermit_c3'),
      title: "Regole Permessi",
      url: "/workpermitrules",
      icon: <AssignmentTurnedInIcon style={{ fontSize: iconSize }} />
    },
    // Admin-only
    {
      hasPermission: hasPermission(permissions, 'base.show_business_intelligence'),
      title: "Analisi pesi/volumi",
      url: "/delivery_mergers",
      icon: <GroupWorkIcon style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: user?.is_admin === true,
      title: "Analisi giri",
      url: "/route_summaries",
      icon: <GroupWorkIcon style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: user?.is_admin === true,
      title: "Muletti",
      url: "/forklifts",
      icon: <MdForklift style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: user?.is_admin === true,
      title: "Email",
      url: "/emails",
      icon: <MdOutlineMailOutline style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: user?.is_admin === true,
      title: "Info permessi",
      url: "/permission_info",
      icon: <LuFolderTree style={{ fontSize: iconSize }} />
    },
    {
      hasPermission: user?.is_admin === true,
      title: "Verifica contatore",
      url: "/check_counter",
      icon: <GoCodescanCheckmark style={{ fontSize: iconSize }} />
    }
  ];

  const visibleCards = cards
    .filter(card => card.hasPermission)
    .filter(card => card.title.toLowerCase().includes(search.toLowerCase()));

  return (
    <Box style={{ padding: theme.spacing(1), paddingBottom: theme.spacing(1) }}>
      <Typography variant="h4" align="center" gutterBottom>
        Bentornato, <Box component="span" style={{ fontWeight: theme.typography.fontWeightBold }}>{user.username}</Box>
      </Typography>

      {user.is_internal_user && user.has_badge && (
        <Box textAlign="center" marginBottom={theme.spacing(1)}>
          <PresenceButton user={user} bigButton />
        </Box>
      )}

      <Box display="flex" justifyContent="center" maxWidth={600} margin="0 auto" marginBottom={theme.spacing(0.5)} className={classes.searchField}>
        <TextField
          variant="outlined"
          size="small"
          fullWidth
          placeholder="Cerca sezione..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </Box>

      <Grid container>
        {user?.is_carrier ? <></> : visibleCards.map((card, idx) => (
          <FirstPageCard
            key={card.title}
            title={card.title}
            url={card.url}
            icon={card.icon}
            delay={idx * 100}
          />
        ))}
      </Grid>

      <Box marginTop={theme.spacing(1)} marginBottom={theme.spacing(1)}>
        <Typography variant="h5" gutterBottom>
          Funzioni utili
        </Typography>
        <Grid container spacing={1} justifyContent="center">
          <Grid item>
            <ChangePassword />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
